<template>
  <SpFinder
    id="1"
    ref="finder"
    :show-tool-bar="false"
    :no-selection="true"
    class="channelCode"
    :url="{
      data: requestUrl + '/customer/group_welcome-msg/get-list'
    }"
    title="数据"
    :columns="columns"
    :actions="actions"
  />
</template>

<script>
export default {
  data () {
    const columns = [
      {
        name: '消息内容', // 表头
        key: 'text_msg' // 匹配data key
      },
      {
        name: '创建时间', // 表头
        key: 'created_at', // 匹配data key
        width: 180
      },
      {
        name: '更新时间', // 表头
        key: 'updated_at', // 匹配data key
        width: 180
      }
    ]

    const actions = [
      {
        name: '新建欢迎语',
        key: 'create', // 用于指定key,必填
        slot: 'header',
        type: 'button',
        buttonType: 'primary',
        action: {
          type: 'link',
          path: '/membership/membershipWelcome/0'
        }
      },
      {
        name: '编辑',
        key: 'edit',
        type: 'button',
        action: {
          type: 'link',
          path: (row, selections) => `/membership/membershipWelcome/${row.id}` // 方法方式跳转
        }
      },
      {
        name: '删除',
        key: 'delete',
        type: 'button',
        action: {
          type: 'api',
          path: '/customer/welcome-msg/delete/${id}', // api url
          onSuccess: () => {
            this.$refs.finder.refresh()
          },
          confirm: {
            message: '请确认是否删除？',
            title: '提示'
          }
        }
      }
    ]

    return {
      columns,
      actions,
      requestUrl: process.env.VUE_APP_BASE_API
    }
  },

  methods: {}
}
</script>
<style lang="scss">
.channelcode-hover-pic {
  .hover-img {
    display: block;
    width: 150px;
    height: 150px;
  }
}
.channel-list-first {
  .channel-list-code {
    width: 60px;
    height: 60px;
  }
}
</style>
